import React from 'react';
import { CorporateEditTemplate } from 'themes/application/corporate/pages';
import { observer } from 'mobx-react';
import { CorporateEditViewStore } from 'application/corporate/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new CorporateEditViewStore(rootStore), 'editView')
@observer
class CorporateEdit extends React.Component {
    render() {
        return <CorporateEditTemplate {...this.props} />
    }
}

export default CorporateEdit;
